import { render, staticRenderFns } from "./SearchPatientModal.vue?vue&type=template&id=374b6288&"
import script from "./SearchPatientModal.vue?vue&type=script&lang=js&"
export * from "./SearchPatientModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports